import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../app_state';

@Component({
  selector: 'yi-testimonial-2',
  template: require('./testimonial2.component.html'),
  styles: [require('./testimonial.component.scss')]
})
export class Testimonial2Component {
  isLastStep = false;
  lastStepName = '';

  constructor(
    private store: Store<IAppState>,
    private translateService: TranslateService
  ) {
    this.store.select(state => state.app.install.navigation).subscribe(
      items => {
        let currentStep = items.navigationItems.filter(item => item.active === true)[0];
        this.isLastStep = currentStep.isLastStep;
        this.lastStepName = (this.translateService.instant(currentStep.name) + '-last-step').toLowerCase();
      });
  }
}
